(function () {
  // Libre Punto: prueba de rendimiento sin transiciones de página.
  // Quitamos inmediatamente cualquier bloqueador heredado del tema.
  document.getElementById('view-transition-render-blocker')?.remove();
})();
